import { PropsWithChildren } from 'react';
import { useParams } from 'react-router-dom';

import { useEmailSso } from '@newfold/huapi-js';
import { EmailSsoParams } from '@newfold/huapi-js/src/index.schemas';

import useAccount from '~/hooks/useAccount';

import SSOComponent from '../index';
import { SSO_HOOK_OPTIONS } from '../utils/helpers';
import { BaseSsoProps } from '../utils/types';

interface WebmailSSOProps extends BaseSsoProps {
  hostingId?: string | number;
}

const WebmailSSO = ({
  children = undefined,
  hostingId = undefined,
  queryParams = {},
  disabled = false,
  ...props
}: PropsWithChildren<WebmailSSOProps>) => {
  const { siteId } = useParams();
  const { id: accountHostingId } = useAccount();
  const accountId = hostingId || accountHostingId;

  const sso = useEmailSso(
    accountId,
    queryParams as EmailSsoParams,
    SSO_HOOK_OPTIONS,
  );

  return (
    <SSOComponent
      sso={sso}
      isDisabled={disabled}
      siteId={siteId}
      hostingId={hostingId}
      {...props}
    >
      {children}
    </SSOComponent>
  );
};

export default WebmailSSO;
